import React from 'react'
import $ from 'jquery';
import '../Styles/Testimonials.css'
import TestimonialMan from '../assets/images/testimonials_man.png'
import Footer from '../Components/Footer'
import Navbar from '../Components/Navbar'
import BottomCarousel from '../Components/BottomCarousel'
function Testimonials() {
// Accordian Action
var action = 'click';
var speed = "500";
// Document Ready
$(document).ready(function(){
// Question handler
$('li.q').on(action, function(){
// Check if the current question is already opened
var isOpen = $(this).hasclassName('rotate');
// Reset all other questions
$('li.q').removeclassName('rotate');
$('li.a').slideUp(speed);
// Open or close the current question accordingly
if (!isOpen) {
$(this).addclassName('rotate');
$(this).next().slideDown(speed);
}
}); // End on click
}); // End Ready
$(document).ready(function(){
   $('.customer_carousel2').owlCarousel({
     loop:true,
     margin:0,
     
     autoplay:true,
     autoplayTimeout:3000,
     autoplayHoverPause:true,
     nav:false,
     dots:true,
     responsive:{
         0:{
             items:1
         },
         320:{
             items:1
         },
         480:{
             items:1
         },
         600:{
             items:1
         },
         767:{
             items:1
         },
         991:{
             items:1
         },
         1200:{
             items:2
         }
     }
 });
 });	
$(document).ready(function(){
$('.owl-carousel').owlCarousel({
items: 10, // Number of items visible at once
loop: true, // Loop the carousel
margin: 10, // Space between items
autoplay: true, // Autoplay the carousel
autoplayTimeout: 3000, // Autoplay interval in milliseconds
responsive: {
0: {
items: 1
},
768: {
items: 2
},
1024: {
items: 4
}
}
});
});
return (
<div className="App">
   <header className="header">
      <section className='backgroung-image-testimonails'>
         <Navbar/>
         <div className='header-about-content'>
            <h1>.</h1>
         </div>
      </section>
   </header>
   <main className="main">
      <section className='container about-success'>
         <div className='Testimonials-success-work'>
            {/* <!------what start--------> */}
            <div className="testimonials-bg">
               <div className="container">
                  <div className="row">
                     <h5>testimonials</h5>
                     <h2><span>What</span> Client Says</h2>
                     <div class="testimonials-bg">
	<div class="container">		
       <div class="row">
		   <ul>
			   <li>
				   <div class="box">
					   <p>We entrusted and awarded ATP to BRiX for PAN-india in early 2015.They have excelled by enabling 35+ Extreme Certified Specialist and 40+ extreme certified Expert in the first 18 months of their operation which helped our channel partner in great extended to handle growing business and technical support services.Most importantly , quality delivery with their Brand conscious is excited us. Best wishes to team BRiX.</p>
					   <div class="in-box">
                  <img src={TestimonialMan} alt="Testimonial" />
						   <h4>Regional Director-Channel</h4>
						   <h6>SAARC Region, extreme networks</h6>
					   </div>
				   </div>
			   </li>
			   <li>
				   <div class="box">
					   <p>Unique delivery by studying participants .Best wishes from us to create brand in the ATD.</p>
					   <div class="in-box">
                  <img src={TestimonialMan} alt="Testimonial" />
						   <h4>Executive</h4>
						   <h6>IT, MuSigma</h6>
					   </div>
				   </div>
			   </li>
			   <li>
				   <div class="box">
					   <p>Really Impresed , Subject Matter Expert , methedology and their tools .</p>
					   <div class="in-box">
						<img src={TestimonialMan} alt="Testimonial" />
						   <h4>Manager</h4>
						   <h6>HR, netcon technologies</h6>
					   </div>
				   </div>
			   </li>
		   </ul>
		</div>
	</div>
</div>
                  </div>
               </div>
            </div>
            {/* <!------success end--------> */}
         </div>
      </section>
      {/* Brand Section Start */}
      <BottomCarousel/>
      {/* Brand Section end */}
   </main>
   {/* <!------footer start--------> */}
   <Footer/>
   {/* <!------footer end--------> */}
</div>
);
}
export default Testimonials;